import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
import AppBar from '../components/core/AppBar.vue'
import Farmers from '../views/Farmers.vue'
import Farmersview from '../views/Farmersview.vue'
import Login from '../views/Login.vue'
import Akfimsfarmer from '../views/Akfimsfarmer.vue'
import Akfimstable from '../views/Akfimstable.vue'
import Enumeratorstable from '../views/Enumeratorstable.vue'
import Enumerator from '../views/Enumerator.vue'

import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: AppBar,
    children: [
      {
        path: '/',
        name: 'Dashboard',
        component: Dashboard
      },
      {
        path: '/farmers',
        name: 'Farmers',
        component: Farmers
      },
      {
        path: '/farmersview',
        name: 'Farmersview',
        component: Farmersview
      },
      {
        path: '/akfimsfarmers/:id',
        name: 'Akfimsfarmer',
        component: Akfimsfarmer
      },
      {
        path: '/akfimsfarmers',
        name: 'Akfimstable',
        component: Akfimstable
      },
      {
        path: '/enumerator',
        name: 'Enumerator',
        component: Enumerator
      },
      {
        path: '/enumeratorstable',
        name: 'Enumeratorstable',
        component: Enumeratorstable
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      allowAnonymous: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name === 'Login' && store.state.auth.isAdminLoggedIn) {
    next({ path: '/' })
  } else if (!to.meta.allowAnonymous && !store.state.auth.isAdminLoggedIn) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
})

export default router
